const FALLBACK = [
  "Aureon ID · Private",
  "Top 25 Crypto",
  "Mega-Caps",
  "Precious Metals",
  "Global Forex",
  "Live market data",
  "Simulated book",
];

const fmtPrice = (n) =>
  n == null
    ? "—"
    : n >= 1000
      ? n.toLocaleString("en-US", { maximumFractionDigits: 0 })
      : n >= 1
        ? n.toLocaleString("en-US", { maximumFractionDigits: 2 })
        : n.toFixed(4);

export default function TickerTape({ coins }) {
  const live = coins && coins.length > 0;
  return (
    <section
      data-testid="live-ticker-tape"
      aria-label={live ? "Live crypto prices" : "Aureon highlights"}
      className="overflow-hidden border-y border-gold/20 bg-black/40 py-4 backdrop-blur-sm"
    >
      <div className="flex w-max animate-marquee-slow items-center gap-12 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-12">
            {(live ? [...coins, ...coins] : FALLBACK).map((c, i) =>
              live ? (
                <span key={`${half}-${i}`} className="flex items-center gap-3 font-tabular text-xs tracking-wider">
                  <span className="text-gold">{c.symbol.toUpperCase()}</span>
                  <span
                    className="text-white/85"
                    data-testid={half === 0 ? `tape-price-${c.symbol}` : undefined}
                  >
                    ${fmtPrice(c.price)}
                  </span>
                  <span
                    className={
                      (c.change_24h ?? 0) >= 0
                        ? "text-[#00FF41] drop-shadow-[0_0_6px_rgba(0,255,65,0.4)]"
                        : "text-[#FF003C] drop-shadow-[0_0_6px_rgba(255,0,60,0.4)]"
                    }
                  >
                    {(c.change_24h ?? 0) >= 0 ? "+" : ""}
                    {(c.change_24h ?? 0).toFixed(2)}%
                  </span>
                  <span className="ml-6 h-1 w-1 rotate-45 bg-gold/40" />
                </span>
              ) : (
                <span key={`${half}-${i}`} className="flex items-center gap-12">
                  <span className="text-xs uppercase tracking-[0.35em] text-gold/70">{c}</span>
                  <span className="h-1 w-1 rotate-45 bg-gold/40" />
                </span>
              ),
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
